import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["value", "onInput"]
const _hoisted_2 = {
  key: 7,
  class: "mb-8"
}
const _hoisted_3 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_6 = { class: "required" }
const _hoisted_7 = { class: "nested-card mb-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DisplayBlock = _resolveComponent("DisplayBlock")!
  const _component_ImageInput = _resolveComponent("ImageInput")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_TextareaInput = _resolveComponent("TextareaInput")!
  const _component_HtmlEditorInput = _resolveComponent("HtmlEditorInput")!
  const _component_ActionButtonsInput = _resolveComponent("ActionButtonsInput")!
  const _component_MapInput = _resolveComponent("MapInput")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_CheckboxesGroup = _resolveComponent("CheckboxesGroup")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_GameSelectWithPicker = _resolveComponent("GameSelectWithPicker")!
  const _component_SelectedOrderChips = _resolveComponent("SelectedOrderChips")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_NestedArrayInput = _resolveComponent("NestedArrayInput")!
  const _component_ChipsNumberArrayInput = _resolveComponent("ChipsNumberArrayInput")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputs, (input, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["d-flex flex-column fv-row", input.customClass || ''])
    }, [
      (input.type === 'display')
        ? (_openBlock(), _createBlock(_component_DisplayBlock, {
            key: 0,
            input: input,
            values: _ctx.values
          }, null, 8, ["input", "values"]))
        : (input.type === 'hidden')
          ? (_openBlock(), _createElementBlock("input", {
              key: 1,
              type: "hidden",
              value: _ctx.getField(input.name),
              onInput: ($event: any) => (_ctx.setField(input.name, $event.target.value))
            }, null, 40, _hoisted_1))
          : (input.type === 'image')
            ? (_openBlock(), _createBlock(_component_ImageInput, {
                key: 2,
                input: input,
                values: _ctx.values,
                "model-value": _ctx.getField(input.name),
                "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.name, $event))
              }, null, 8, ["input", "values", "model-value", "onUpdate:modelValue"]))
            : (_ctx.isText(input))
              ? (_openBlock(), _createBlock(_component_TextInput, {
                  key: 3,
                  input: input,
                  values: _ctx.values,
                  "model-value": _ctx.getField(input.name),
                  "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.name, $event))
                }, null, 8, ["input", "values", "model-value", "onUpdate:modelValue"]))
              : (input.type === 'textarea' && _ctx.showByCondition(input))
                ? (_openBlock(), _createBlock(_component_TextareaInput, {
                    key: 4,
                    input: input,
                    values: _ctx.values,
                    "model-value": _ctx.getField(input.name),
                    "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.name, $event))
                  }, null, 8, ["input", "values", "model-value", "onUpdate:modelValue"]))
                : (input.type === 'htmlEditor' && _ctx.showByCondition(input))
                  ? (_openBlock(), _createBlock(_component_HtmlEditorInput, {
                      key: 5,
                      input: input,
                      "model-value": _ctx.getField(input.name),
                      "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.name, $event))
                    }, null, 8, ["input", "model-value", "onUpdate:modelValue"]))
                  : (input.type === 'apiButtons' && _ctx.showByCondition(input))
                    ? (_openBlock(), _createBlock(_component_ActionButtonsInput, {
                        key: 6,
                        input: input,
                        values: _ctx.values,
                        id: _ctx.id
                      }, null, 8, ["input", "values", "id"]))
                    : (input.type === 'button')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("label", _hoisted_3, [
                            _createElementVNode("span", null, _toDisplayString(input.label), 1)
                          ]),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-primary",
                            type: "button",
                            onClick: ($event: any) => (input.toggleHasLocation(_ctx.values))
                          }, _toDisplayString(_ctx.values.hasLocation ? 'Remove Location' : 'Add Location'), 9, _hoisted_4)
                        ]))
                      : (input.type === 'map')
                        ? (_openBlock(), _createBlock(_component_MapInput, {
                            key: 8,
                            input: input,
                            values: _ctx.values
                          }, null, 8, ["input", "values"]))
                        : (input.type === 'checkbox')
                          ? (_openBlock(), _createBlock(_component_CheckboxInput, {
                              key: 9,
                              input: input,
                              "model-value": _ctx.getField(input.name),
                              "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.name, $event))
                            }, null, 8, ["input", "model-value", "onUpdate:modelValue"]))
                          : (input.type === 'password')
                            ? (_openBlock(), _createBlock(_component_PasswordInput, {
                                key: 10,
                                input: input,
                                id: _ctx.id,
                                "model-value": _ctx.getField(input.name),
                                "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.name, $event))
                              }, null, 8, ["input", "id", "model-value", "onUpdate:modelValue"]))
                            : (input.type === 'checkboxes' && _ctx.relationships)
                              ? (_openBlock(), _createBlock(_component_CheckboxesGroup, {
                                  key: 11,
                                  input: input,
                                  options: _ctx.relationships[input.name],
                                  values: _ctx.values,
                                  "model-value": _ctx.getField(input.name),
                                  "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.name, $event))
                                }, null, 8, ["input", "options", "values", "model-value", "onUpdate:modelValue"]))
                              : (input.type === 'date' && _ctx.showByCondition(input))
                                ? (_openBlock(), _createBlock(_component_DateInput, {
                                    key: 12,
                                    input: input,
                                    "model-value": _ctx.getField(input.name),
                                    "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.name, $event))
                                  }, null, 8, ["input", "model-value", "onUpdate:modelValue"]))
                                : (_ctx.isRelationshipSelect(input) && input.isPicker)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                                      _createElementVNode("label", _hoisted_5, [
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(input.label), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_7, [
                                        _createVNode(_component_GameSelectWithPicker, {
                                          input: input,
                                          options: _ctx.relationships[input.name],
                                          "model-value": _ctx.getField(input.nameForDb ? input.nameForDb : input.valueAttr),
                                          "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.nameForDb ? input.nameForDb : input.valueAttr, $event)),
                                          disabled: false,
                                          "hide-select": input.hideInput
                                        }, null, 8, ["input", "options", "model-value", "onUpdate:modelValue", "hide-select"]),
                                        _createVNode(_component_SelectedOrderChips, {
                                          "model-value": _ctx.getField(input.nameForDb ? input.nameForDb : input.valueAttr),
                                          "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.nameForDb ? input.nameForDb : input.valueAttr, $event)),
                                          options: _ctx.relationships[input.name],
                                          "label-prop": input.multiSelectLabel || 'name'
                                        }, null, 8, ["model-value", "onUpdate:modelValue", "options", "label-prop"])
                                      ])
                                    ], 64))
                                  : (_ctx.isRelationshipSelect(input) && !input.isPicker)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 14 }, [
                                        _createVNode(_component_SelectInput, {
                                          input: input,
                                          mode: 'relationships',
                                          options: _ctx.relationships[input.name],
                                          "model-value": _ctx.getField(input.nameForDb ? input.nameForDb : input.valueAttr),
                                          "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.nameForDb ? input.nameForDb : input.valueAttr, $event)),
                                          disabled: false
                                        }, null, 8, ["input", "options", "model-value", "onUpdate:modelValue"]),
                                        (input.enableOrder && input.value === 'multiple')
                                          ? (_openBlock(), _createBlock(_component_SelectedOrderChips, {
                                              key: 0,
                                              "model-value": _ctx.getField(input.nameForDb ? input.nameForDb : input.valueAttr),
                                              "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.nameForDb ? input.nameForDb : input.valueAttr, $event)),
                                              options: _ctx.relationships[input.name],
                                              "label-prop": input.multiSelectLabel || 'name'
                                            }, null, 8, ["model-value", "onUpdate:modelValue", "options", "label-prop"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (_ctx.isCustomSelect(input))
                                      ? (_openBlock(), _createBlock(_component_SelectInput, {
                                          key: 15,
                                          input: input,
                                          mode: 'custom',
                                          options: input.customOptions ? input.customOptions() : [],
                                          "model-value": _ctx.getField(input.nameForDb ? input.nameForDb : input.valueAttr),
                                          "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.nameForDb ? input.nameForDb : input.valueAttr, $event)),
                                          disabled: !!(input.isDisabled && input.isDisabled(_ctx.isEditMode))
                                        }, null, 8, ["input", "options", "model-value", "onUpdate:modelValue", "disabled"]))
                                      : (input.type === 'selectFromArray')
                                        ? (_openBlock(), _createBlock(_component_SelectInput, {
                                            key: 16,
                                            input: input,
                                            mode: 'array',
                                            options: _ctx.relationships[input.name],
                                            "model-value": _ctx.getField(input.nameForDb ? input.nameForDb : input.valueAttr),
                                            "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.nameForDb ? input.nameForDb : input.valueAttr, $event)),
                                            disabled: false
                                          }, null, 8, ["input", "options", "model-value", "onUpdate:modelValue"]))
                                        : (input.type === 'nestedArray')
                                          ? (_openBlock(), _createBlock(_component_NestedArrayInput, {
                                              key: 17,
                                              input: input,
                                              relationships: _ctx.relationships,
                                              "model-value": _ctx.getField(input.nameForDb ? input.nameForDb : input.valueAttr),
                                              "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.nameForDb ? input.nameForDb : input.valueAttr, $event)),
                                              onAdd: ($event: any) => (_ctx.emitAddNestedRow(input.name)),
                                              onRemove: ($event: any) => (_ctx.emitRemoveNestedRow(input.name, $event))
                                            }, null, 8, ["input", "relationships", "model-value", "onUpdate:modelValue", "onAdd", "onRemove"]))
                                          : (input.type === 'chipsNumberArray' && _ctx.showByCondition(input))
                                            ? (_openBlock(), _createBlock(_component_ChipsNumberArrayInput, {
                                                key: 18,
                                                input: input,
                                                "model-value": _ctx.getField(input.nameForDb ? input.nameForDb : input.valueAttr),
                                                "onUpdate:modelValue": ($event: any) => (_ctx.setField(input.nameForDb ? input.nameForDb : input.valueAttr, $event)),
                                                onAdd: ($event: any) => (_ctx.emitAddTier(input.name, $event)),
                                                onRemove: ($event: any) => (_ctx.emitRemoveTier(input.name, $event))
                                              }, null, 8, ["input", "model-value", "onUpdate:modelValue", "onAdd", "onRemove"]))
                                            : _createCommentVNode("", true)
    ], 2))
  }), 128))
}